import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Card3dsFlowDto } from "@src/api-new/generated-api.schemas";


interface ThreeDSecureState {
  card3dsFlowResponse: Card3dsFlowDto
}

const initialState: ThreeDSecureState = {
  card3dsFlowResponse: {}
};

const threeDSecureSlice = createSlice({
  name: "threeDSecure",
  initialState,
  reducers: {
    startThreeDSFlow(state, action: PayloadAction<Card3dsFlowDto>) {
      state.card3dsFlowResponse = action.payload;
    },
    threeDsFinished(state) {
      return state;
    },
    dfpFinished(state) {
      return state;
    },
    finalizeDfp(state) {
      return state;
    },
    flowSucceeded(state) {
      return state;
    },
    flowFailed(state) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});

const reducer = threeDSecureSlice.reducer;
const actions = threeDSecureSlice.actions;

export {
  reducer as default,
  actions as threeDSecureActions
};
